import { removeTrapFocus, trapFocus } from '../storefront/globals';

export default class SidebarMenu extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      'keyup',
      (evt) => evt.code === 'Escape' && this.close(),
    );

    this.querySelector('#SidebarMenu-Overlay').addEventListener(
      'click',
      this.close.bind(this),
    );

    this.setSidebarMenuButton();

    if (Shopify.designMode) {
      this.setSectionListeners();
    }
  }

  setSidebarMenuButton() {
    const sidemenuButton = document.querySelector('.js-header-sidemenu-button');

    if (!sidemenuButton) return;

    sidemenuButton.setAttribute('role', 'button');
    sidemenuButton.setAttribute('aria-haspopup', 'dialog');

    sidemenuButton.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(sidemenuButton);
    });

    sidemenuButton.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(sidemenuButton);
      }
    });
  }

  setSectionListeners() {
    document.addEventListener('shopify:section:select', (event) => {
      const { sectionId } = event.detail;
      if (sectionId === 'sidebar-menu') {
        this.open();
      }
    });

    document.addEventListener('shopify:section:deselect', (event) => {
      const { sectionId } = event.detail;
      if (sectionId === 'sidebar-menu') {
        this.close();
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    setTimeout(() => {
      this.setAttribute('open', '');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.querySelector('[role="dialog"');

        trapFocus(containerToTrapFocusOn);
      },
      { once: true },
    );

    document.body.classList.add('overflow-hidden');
    document.dispatchEvent(new CustomEvent('header:side-menu:open'))
  }

  close() {
    this.removeAttribute('open');
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);

    document.body.classList.remove('overflow-hidden');
    document.dispatchEvent(new CustomEvent('header:side-menu:close'))
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('sidebar-menu', SidebarMenu);
